import { createSelector } from '@reduxjs/toolkit';
import { EElevators } from '../../../../packages/api-models/common/json_query';
import { EElevatorType } from '../../../../packages/JsonQuery';
import { selectLifts, selectLiftService } from 'shared/selectors/jsonQuery';

export const selectElevatorsValue = createSelector([selectLifts, selectLiftService], (lifts, liftService) => {
  switch (true) {
    case liftService && liftService.gte && liftService.gte > 0:
      return EElevatorType.Service;

    case lifts !== null && lifts !== EElevators.Any:
      return EElevatorType.Any;

    default:
      return null;
  }
});
